import axios from "axios";
import { baseURL, devKey } from "../../../util/config";
import { GET_AFFILIATE_REQUEST, ACCEPT_AFFILIATE_REQUEST, REJECT_AFFILIATE_REQUEST } from "./affiliateRequest.type";

// Get all affiliate requests
export const getAffiliateRequest = (page, size, search) => (dispatch) => {
  // Backend expects start as page number (1-based)
  const url = `${baseURL}affiliateRequest/getAll?start=${page}&limit=${size}`;

  axios
    .get(url)
    .then((res) => {
      dispatch({
        type: GET_AFFILIATE_REQUEST,
        payload: {
          data: res.data.request,
          total: res.data.totalrequest
        },
      });
    })
    .catch((error) => {
      console.error("Error fetching affiliate requests:", error.response || error);
    });
};

// Accept affiliate request
export const acceptAffiliateRequest = (id) => (dispatch) => {
  console.log("Calling API to accept request:", id);
  return axios
    .patch(`${baseURL}affiliateRequest/accept?requestId=${id}`)
    .then((res) => {
      console.log("Accept API response:", res.data);
      dispatch({
        type: ACCEPT_AFFILIATE_REQUEST,
        payload: id,
      });
      return res.data;
    })
    .catch((error) => {
      console.error("Error accepting affiliate request:", error.response || error);
      // Show the actual error to the user
      if (error.response) {
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
      }
      throw error;
    });
};

// Delete / reject affiliate request
export const rejectAffiliateRequest = (id) => (dispatch) => {
  return axios
    .delete(`${baseURL}affiliateRequest/delete?requestId=${id}`)
    .then((res) => {
      dispatch({
        type: REJECT_AFFILIATE_REQUEST,
        payload: id,
      });
      return res.data;
    })
    .catch((error) => {
      console.error("Error deleting affiliate request:", error.response || error);
      throw error;
    });
};